import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import TextArea from 'app/components/TextArea'
import RatedStars from 'app/components/RatedStars'
import image from 'app/assets/images/doneProtrack.svg'
import { required, maxLength } from 'helpers/validators'
import './styles.scss'

const bc = 'protrack-finished'

const UserProtrackRating = ({ t, handleSubmit, previousProTrack, submitting, pristine, onDismiss }) => (
  <div className={`${bc}__wrapper`}>
    <div className={`${bc}__form`}>
      <form onSubmit={handleSubmit}>
        <div className={`${bc}__row`}>
          <div className={`${bc}__congratulation`}>{t('user:Awesome!')}</div>
          <div className={`${bc}__title`}>
            {t('user:Please help us improve by rating')}{' '}
            <b>{`${previousProTrack.get('proTrackName')} (${previousProTrack.get('name')})`}</b>
          </div>
          <div className={`${bc}__rated-stars`}>
            <Field name="rate" component={RatedStars} validate={[required(t('user:Please add a rating'))]} />
          </div>
        </div>
        <div className={`${bc}__row`}>
          <Field
            name="comment"
            component={TextArea}
            type="text"
            placeholder={t('user:Add your comment here (optional)')}
            validate={[maxLength(255)]}
          />
        </div>
        <div className={`${bc}__buttons`}>
          <Button type="submit" xs primary className={`${bc}__button`} submitting={submitting} disabled={pristine}>
            {t('Submit')}
          </Button>
          <Button xs className={`${bc}__button`} onClick={onDismiss}>
            {t('DISMISS')}
          </Button>
        </div>
      </form>
    </div>
    <div className={`${bc}__image`}>
      <img src={image} alt="done proTrack" />
    </div>
  </div>
)

UserProtrackRating.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  previousProTrack: PropTypes.object.isRequired,
}

export default withTranslation()(UserProtrackRating)
